import React from 'react';
import logo from 'assets/images/logo_lawft_transparent.png';

export default function PoweredBy() {
  return (
    <div className="w-100 d-flex justify-content-center align-items-center my-3">
      <label className="p-2 me-1">
        <b>Powered by</b>
      </label>
      <img src={logo} alt="logo" width="88" height="18" />
    </div>
  );
}
